import React, { useState, useReducer, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { getServerUrl } from "../../config";
import axios from "axios";
import {
  Table,
  Space,
  Breadcrumb,
  Select,
  Input,
  Button,
  Row,
  notification,
  Form,
  Col,
  Tag,
  DatePicker,
  Result,
  message,
  Modal,
} from "antd";
import Highlighter from "react-highlight-words";
import moment from "moment";
import { PlusCircleFilled, CheckCircleFilled } from "@ant-design/icons";
import { SearchOutlined } from "@ant-design/icons";
const { Option } = Select;

const MoveStock = (props) => {
  const [formtwo] = Form.useForm();
  const [details, setdetails] = useState("");
  const [newdetails, setnewdetails] = useState("");
  const [data, setdata] = useState("");
  const [searchInput, setsearchInput] = useState([""]);
  const [searchText, setsearchText] = useState([""]);
  const [searchedColumn, setsearchedColumn] = useState([""]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [userInput, setUserInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      cs_id: "",
      quantity: "",
      available: "",
      entered_quantity: "",
      scrap_quantity: "",
    }
  );
  const handleChange = (e) => {
    const name = e.target.name;
    const newValue = e.target.value;
    setUserInput({ [name]: newValue });
  };
  useEffect(() => {
    axios
      .get(`${getServerUrl()}/inventory/getcompletecomponentlist/`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = res.data.data;
        const details = responsevalue;
        setdata(details);
      });
  }, []);

  const moveStock = (cs_id, quantity, completed) => {
    setIsModalVisible(true);
    userInput.cs_id = cs_id;
    userInput.available = quantity - completed;
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            setsearchInput(node);
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        //setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setsearchedColumn(dataIndex);
    setsearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setsearchText("");
  };
  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0].substring(2), // get only two digits
      month = datePart[1],
      day = datePart[2];

    return day + "/" + month + "/" + year;
  }
  const columns = [
    {
      title: "Date",
      dataIndex: "stock_date",
      key: "stock_date",
      render: (text, record) => record.stock_date,
      ...getColumnSearchProps("stock_date"),
    },
    {
      title: "Contractor",
      dataIndex: "contractor_name",
      key: "contractor_name",
      ...getColumnSearchProps("contractor_name"),
    },
    {
      title: "Batch",
      dataIndex: "batch_no",
      key: "batch_no",
      ...getColumnSearchProps("batch_no"),
    },
    {
      title: "Componenent Name",
      dataIndex: "component_name",
      key: "component_name",

      ...getColumnSearchProps("component_name"),
    },
    {
      title: "Componenent No",
      dataIndex: "component_no",
      key: "component_no",

      ...getColumnSearchProps("component_no"),
    },

    {
      title: "Complete Process",
      dataIndex: "processName",
      key: "processName",
      ...getColumnSearchProps("processName"),
    },
    {
      title: "Total Stock",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Completed Stock",
      dataIndex: "completed",
      key: "completed",
    },
    {
      title: "Add to Trip",
      dataIndex: "rawmaterial_weight",
      key: "rawmaterial_weight",
      fixed: "right",
      render: (text, record) => (
        <Button
          onClick={() =>
            moveStock(record.cs_id, record.quantity, record.completed)
          }
        >
          Move Stock
        </Button>
      ),
    },
  ];

  const handleConfirmCancel = () => {
    setIsConfirmModalVisible(false);
  };
  function PickUpTimeChange(date, dateString) {
    console.log(dateString);
  }
  /* Open Notifications */
  const openNotification = (type) => {
    notification[type]({
      message: "Stock Moved",
      description: "Stock Moved successfully",
      placement: "bottomRight",
    });
  };
  const handleOk = () => {
    axios
      .post(`${getServerUrl()}/transcation/movestock`, userInput, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        const data = res.data;
        if (data.success === 1) {
          openNotification("success");
          setInterval(() => (window.location.href = "/move-stock/"), 1000);
        } else {
        }
      });
    setIsConfirmModalVisible(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Inventory </Breadcrumb.Item>
        <Breadcrumb.Item>Moved to Finished Stock</Breadcrumb.Item>
      </Breadcrumb>
      <div
        className="site-layout-background"
        style={{ padding: 24, minHeight: 360 }}
      >
        <h2 className="titles">
          MOVE <span>FINISHED STOCK</span>
        </h2>

        <Space></Space>
        <br />
        <Table scroll={{ x: 1300 }} columns={columns} dataSource={data}></Table>
      </div>
      <Modal
        title={"Add Destination"}
        visible={isModalVisible}
        onOk={
          Number(userInput.available) >= Number(userInput.entered_quantity)
            ? handleOk
            : handleCancel
        }
        onCancel={handleCancel}
      >
        <Form layout="vertical" form={formtwo}>
          Avail Quantity{" "}
          <b style={{ color: "green" }}> {Number(userInput.available)}</b>
          <Form.Item name="Quantity" label="Quantity">
            <Input
              name="entered_quantity"
              placeholder="Quantity"
              value={userInput.entered_quantity}
              onChange={handleChange}
            ></Input>
          </Form.Item>
          <Form.Item name="Scrap Quantity" label="Scrap Quantity">
            <Input
              name="scrap_quantity"
              placeholder="Scrap Quantity"
              value={userInput.scrap_quantity}
              onChange={handleChange}
            ></Input>
          </Form.Item>
          {Number(userInput.available) <
          Number(userInput.entered_quantity) + Number(userInput.scrap_quantity)
            ? "Please enter less than avail quantity"
            : ""}
          <Form.Item name="Date" label="Date">
            <DatePicker format={"DD-MM-YYYY"} onChange={PickUpTimeChange} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default MoveStock;
